import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription, forkJoin } from 'rxjs';

import { AgendaCRUDService, AgendaReadOnlySchema, EventCRUDService, EventReadOnlySchema } from '@digitalforest/ngx-oak-api';

import { LoggingService } from '../logging.service';

export interface EventMenuItem extends EventReadOnlySchema {
  label: string;
}

@Component({
  selector: 'app-event-list-page',
  templateUrl: './event-list-page.component.html',
  styleUrls: ['./event-list-page.component.scss'],
  standalone: true,
  imports: [DatePipe],
})
export class EventListPageComponent implements OnInit, OnDestroy {
  eventList: EventReadOnlySchema[] = [];
  eventMenuItemList: EventMenuItem[] = [];
  isLoading = true;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private eventCRUDService = inject(EventCRUDService);
  private agendaCRUDService = inject(AgendaCRUDService);
  private agendaListForCheckIn: AgendaReadOnlySchema[] | null | undefined;
  private logger = inject(LoggingService);
  private subscriptions: Subscription[] = [];

  private companyId = parseInt(this.route.snapshot.paramMap.get('company_id') || '0');

  ngOnInit(): void {
    this.logger.info('[Events] Loading list of events for company', { companyId: this.companyId });
    this.subscriptions.push(
      forkJoin({
        events: this.eventCRUDService.manageGetAllEvents(this.companyId, 'date_begin title', undefined, undefined, undefined),
        agendas: this.agendaCRUDService.manageGetExhibitorAgendaListForCheckIn(this.companyId),
      }).subscribe({
        next: ({ events, agendas }) => {
          this.eventList = events.filter(
            (eventReadOnlySchema: EventReadOnlySchema) => eventReadOnlySchema.active && eventReadOnlySchema.check_in_enabled,
          );

          this.agendaListForCheckIn = agendas.filter(
            (agendaReadOnlySchema: AgendaReadOnlySchema) => agendaReadOnlySchema.active && agendaReadOnlySchema.bookable,
          );

          if (this.agendaListForCheckIn.length > 0) {
            this.router.navigate(['/', 'main', 'agendas', this.companyId]).then();
          }

          this.eventMenuItemList = this.eventList.map((eventReadOnlySchema: EventReadOnlySchema) => {
            const label = eventReadOnlySchema.title || '';

            return {
              ...eventReadOnlySchema,
              label: label,
            };
          });
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  onSelectEvent(eventId: number) {
    this.subscriptions.push(
      this.agendaCRUDService
        .manageGetAllAgendasByEvent(this.companyId, eventId, undefined, undefined, undefined, undefined)
        .subscribe((value) => {
          const agendaList = value.filter((agendaReadOnlySchema: AgendaReadOnlySchema) => agendaReadOnlySchema.bookable);

          if (agendaList.length === 0) {
            this.router.navigate(['/', 'main', 'scan', 'event', this.companyId, eventId]).then();
          } else {
            this.router.navigate(['/', 'main', 'agendas', this.companyId, eventId]).then();
          }
        }),
    );
  }
}
